import React, { useEffect, useState } from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col, Descriptions } from 'antd';
import { Link } from 'react-router-dom';
import QuoteItemInformation from '../../components/Quotes/QuoteItemInformation';
import { AsyncInputNumber, Price } from '@partsbadger/library';
import { QuoteLineItemProps } from '../../types/types';
import QuoteStore from '../../stores/QuoteStore';

interface Props {
    quote_data: QuoteLineItemProps;
    handleAdd: (value: boolean) => void;
    handleSave: (item: { quantity: number; unit_price: string; total_price: string; lead_time: number }) => void;
}

const EditQuoteLineItems = (props: Props) => {
    const [add, setAdd] = useState<boolean>(false);
    const [quantity, setQuantity] = useState<number>(1);
    const [unitPrice, setUnitPrice] = useState<number>(0);
    const [totalPrice, setTotalPrice] = useState<number>(0);
    const [leadTime, setLeadTime] = useState<number>(0);

    const data = props.quote_data;
    useEffect(() => {
        if (data.has_dynamic_quantities && data.quote_item_quantities.length > 0) {
            const fistDynamicQuantity = data.quote_item_quantities[0];
            setQuantity(fistDynamicQuantity.quantity);
            setUnitPrice(Number(fistDynamicQuantity.unit_price));
            setTotalPrice(Number(fistDynamicQuantity.total_price));
            setLeadTime(fistDynamicQuantity.lead_time);
        } else {
            setQuantity(data.quantity);
            setUnitPrice(Number(data.unit_price));
            setTotalPrice(Number(data.total_price));
            setLeadTime(data.lead_time);
        }
    }, []);

    return (
        <>
            <Descriptions layout="horizontal" bordered size="small" column={1}>
                <Descriptions.Item label="Information">
                    <QuoteItemInformation
                        manufacturing_type={data?.manufacturing_type}
                        material_name={data?.product.material}
                        finish_name={data?.product.finish_related?.name}
                        coating_name={data?.product.coating_related?.name}
                    />
                </Descriptions.Item>

                <Descriptions.Item label="Quote">
                    <Link to={`/my-account/quotes/${data.quote}/`}>{data.quote_related.name}</Link>
                </Descriptions.Item>
                <Descriptions.Item label="Lead Time">
                    <span>{leadTime} days</span>
                </Descriptions.Item>
                <Descriptions.Item label="Qty">
                    <div>
                        <AsyncInputNumber
                            min={1}
                            max={data.quantity_max}
                            size="small"
                            defaultValue={quantity}
                            onChange={async qty => {
                                try {
                                    const _data = await QuoteStore.getPriceByQuantity(
                                        props.quote_data.quote,
                                        props.quote_data.id,
                                        qty
                                    );

                                    setQuantity(_data.quantity);
                                    setUnitPrice(Number(_data.unit_price));
                                    setTotalPrice(Number(_data.total_price));
                                    setLeadTime(_data.lead_time);

                                    props.handleSave({
                                        quantity: _data.quantity,
                                        unit_price: _data.unit_price,
                                        total_price: _data.total_price,
                                        lead_time: _data.lead_time,
                                    });
                                } catch (e) {
                                    console.log(e);
                                }
                            }}
                        />
                        <div className={'italic'}>Max Qty {data.quantity_max}</div>
                    </div>
                </Descriptions.Item>
                <Descriptions.Item label="Unit Price">
                    <Price value={unitPrice} />
                </Descriptions.Item>
                <Descriptions.Item label="Total Price">
                    <Price value={totalPrice} />
                </Descriptions.Item>
                <Descriptions.Item label="Action">
                    {!add ? (
                        <Button
                            type="primary"
                            onClick={() => (setAdd(!add), props.handleAdd(!add))}
                            icon={<PlusOutlined style={{ color: '#fff' }} />}
                        >
                            Add To Order
                        </Button>
                    ) : (
                        <Button
                            type="default"
                            onClick={() => (setAdd(!add), props.handleAdd(!add))}
                            icon={<CloseOutlined />}
                        >
                            Remove
                        </Button>
                    )}
                </Descriptions.Item>
            </Descriptions>
        </>
    );
};

export default EditQuoteLineItems;
